import {
  Component, Input, Output, EventEmitter, OnInit,
  ChangeDetectionStrategy, ChangeDetectorRef, inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ShareService, ShareConfig, SharePlatform } from '../../../shared/services/share.service';
import { ToastrService } from 'ngx-toastr';

interface Platform {
  id: SharePlatform;
  label: string;
  bg: string;
  svgContent: SafeHtml;
}

const RAW_ICONS: Record<SharePlatform, string> = {
  reddit:    `<circle cx="12" cy="12" r="10" fill="#FF4500"/><path fill="white" d="M16.5 12a1.5 1.5 0 0 0-2.55-1.07 7.5 7.5 0 0 0-3.92-1.22l.67-3.12 2.14.45a1 1 0 1 0 .1-.96l-2.38-.5a.25.25 0 0 0-.3.19l-.74 3.47a7.52 7.52 0 0 0-3.89 1.22A1.5 1.5 0 1 0 7.6 13.4a2.7 2.7 0 0 0-.04.46c0 2.22 2.6 4.02 5.8 4.02s5.8-1.8 5.8-4.02c0-.16-.01-.31-.04-.46A1.5 1.5 0 0 0 20.5 12h-4zm-7.5 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5.58 2.5a3.5 3.5 0 0 1-2.08.5 3.5 3.5 0 0 1-2.08-.5.25.25 0 0 1 .35-.35 3 3 0 0 0 1.73.37 3 3 0 0 0 1.73-.37.25.25 0 0 1 .35.35zm-.08-1.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>`,
  facebook:  `<circle cx="12" cy="12" r="10" fill="#1877F2"/><path fill="white" d="M13.5 8.5H15V6h-1.5C11.57 6 10 7.57 10 9.5V11H8v2.5h2V22h2.5v-8.5H15l.5-2.5h-3V9.5a1 1 0 0 1 1-1z"/>`,
  twitter:   `<circle cx="12" cy="12" r="10" fill="#000"/><path fill="white" d="M17.6 7h-2l-2.8 3.5L10.4 7H6.5l4.3 5.5L6.5 17h2l3-3.8 2.8 3.8H18l-4.5-5.8L17.6 7z"/>`,
  pinterest: `<circle cx="12" cy="12" r="10" fill="#E60023"/><path fill="white" d="M12 2C6.48 2 2 6.48 2 12c0 4.24 2.65 7.86 6.39 9.29-.09-.78-.17-1.98.04-2.83.18-.77 1.23-5.22 1.23-5.22s-.31-.63-.31-1.57c0-1.47.85-2.57 1.91-2.57.9 0 1.34.68 1.34 1.49 0 .91-.58 2.27-.88 3.53-.25 1.05.52 1.91 1.56 1.91 1.87 0 3.13-2.4 3.13-5.25 0-2.16-1.46-3.68-3.55-3.68-2.42 0-3.84 1.81-3.84 3.69 0 .73.28 1.51.63 1.94.07.08.08.16.06.24l-.24.96c-.04.15-.13.18-.3.11C7.8 13.3 7 11.7 7 10.3 7 7.65 9.09 5 12.63 5c3.08 0 5.47 2.19 5.47 5.12 0 3.06-1.92 5.52-4.59 5.52-.9 0-1.74-.47-2.03-1.02l-.55 2.07c-.2.77-.74 1.73-1.1 2.31.83.26 1.71.4 2.62.4 5.52 0 10-4.48 10-10S17.52 2 12 2z"/>`,
  whatsapp:  `<circle cx="12" cy="12" r="10" fill="#25D366"/><path fill="white" d="M17.47 6.53A7.07 7.07 0 0 0 7.34 16.7L6 18.08l1.38 1.38 1.43-1.34a7.07 7.07 0 0 0 10.26-9.59zM12 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm2.5-4.5c-.27-.13-1.62-.8-1.87-.89-.25-.09-.43-.14-.61.14s-.7.89-.86 1.07c-.16.18-.31.2-.58.07a7.38 7.38 0 0 1-2.17-1.34 8.14 8.14 0 0 1-1.5-1.87c-.16-.27 0-.42.12-.55l.37-.43c.12-.14.16-.27.24-.45.08-.18.04-.34-.02-.47S7.1 8.1 6.87 7.56c-.22-.52-.45-.45-.61-.46h-.52c-.18 0-.47.07-.71.34A2.91 2.91 0 0 0 4.1 9.59a5.06 5.06 0 0 0 1.07 2.7 11.6 11.6 0 0 0 4.44 3.93c.62.27 1.1.43 1.48.55.62.2 1.19.17 1.63.1.5-.07 1.53-.62 1.75-1.22s.21-1.12.15-1.22-.25-.18-.52-.31z"/>`,
  messenger: `<circle cx="12" cy="12" r="10" fill="#0084FF"/><path fill="white" d="M12 2C6.48 2 2 6.48 2 12c0 5 3.66 9.12 8.44 9.88V15.9H8.9v-2.3h1.54v-1.75c0-2.09 1.1-3.24 3.1-3.24.9 0 1.84.16 1.84.16v2.05h-1.04c-1.02 0-1.34.64-1.34 1.29v1.49H15.3l-.37 2.3h-1.93v5.98C17.34 21.12 21 17 21 12c0-5.52-4.48-10-10-10z"/>`,
  email:     `<circle cx="12" cy="12" r="10" fill="#6B7280"/><path fill="white" d="M18 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 2-6 4-6-4v-.5l6 3.75L18 9.5V10z"/>`,
  copy:      `<circle cx="12" cy="12" r="10" fill="#374151"/><path fill="white" d="M15 7H9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm-5 1h4a1 1 0 0 1 1 1v1H9V9a1 1 0 0 1 1-1zm5 9H9v-6h6v6z"/><path fill="white" d="M8 6h5V5H8a1 1 0 0 0-1 1v9h1V6z"/>`,
};

@Component({
  selector: 'app-share-sheet',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './share-sheet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Fixed-position overlay only — the host must not generate a box, or it
  // becomes an empty grid item (and a visible gap) inside the "All" page grid.
  styles: [':host { display: contents; }'],
})
export class ShareSheetComponent implements OnInit {
  @Input() config!: ShareConfig;
  @Input() currentCount = 0;
  @Output() closed = new EventEmitter<void>();
  @Output() countUpdated = new EventEmitter<number>();

  readonly shareService = inject(ShareService);
  private sanitizer = inject(DomSanitizer);
  private toastr = inject(ToastrService);
  private cdr = inject(ChangeDetectorRef);

  platforms: Platform[] = [];
  contentUrl = '';
  copied = false;
  private recording = false;

  ngOnInit(): void {
    this.contentUrl = this.shareService.buildUrl(this.config);
    this.platforms = (Object.keys(RAW_ICONS) as SharePlatform[]).map(id => ({
      id,
      label: this.labelFor(id),
      bg: this.bgFor(id),
      svgContent: this.sanitizer.bypassSecurityTrustHtml(RAW_ICONS[id]),
    }));
  }

  private labelFor(id: SharePlatform): string {
    const labels: Record<SharePlatform, string> = {
      reddit: 'Reddit', facebook: 'Facebook', twitter: 'X (Twitter)',
      pinterest: 'Pinterest', whatsapp: 'WhatsApp', messenger: 'Messenger',
      email: 'Email', copy: 'Copy Link',
    };
    return labels[id];
  }

  private bgFor(id: SharePlatform): string {
    const bgs: Record<SharePlatform, string> = {
      reddit: '#FF4500', facebook: '#1877F2', twitter: '#000000',
      pinterest: '#E60023', whatsapp: '#25D366', messenger: '#0084FF',
      email: '#6B7280', copy: '#374151',
    };
    return bgs[id];
  }

  share(platform: SharePlatform): void {
    if (platform === 'copy') {
      navigator.clipboard.writeText(this.contentUrl).then(() => {
        this.copied = true;
        this.toastr.success('Link copied to clipboard');
        this.cdr.markForCheck();
        setTimeout(() => { this.copied = false; this.cdr.markForCheck(); }, 2000);
      }).catch(() => this.toastr.error('Failed to copy link'));
    } else {
      this.shareService.openPlatform(platform, this.config);
    }

    // Record — one API call per sheet open, not per button click
    if (!this.recording) {
      this.recording = true;
      this.shareService.record(this.config.contentId).subscribe({
        next: (res: any) => {
          this.recording = false;
          const newCount = res?.data?.shares ?? this.currentCount + 1;
          this.currentCount = newCount;
          this.countUpdated.emit(newCount);
          this.cdr.markForCheck();
        },
        error: () => { this.recording = false; }
      });
    }
  }

  close(): void { this.closed.emit(); }
}
